import { useLayoutEffect, useState } from 'react';
import { useSettings } from '@wu/widget-core';
import { sourceContext } from '../SourceContext';
import { errorContext } from './common/errorContext';
import { currentVideoContext } from './currentVideoContext';
import { popupContext } from './popup/PopupContext';

export function Content({ children }) {
  const { source, playMode } = useSettings();

  const [videosSource, setSource] = useState(source);
  const [currentVideo, setCurrentVideo] = useState(null);
  const [showPopup, toggleShowPopup] = useState(false);
  const [playing, togglePlaying] = useState(false);
  const [percent, setCurrentPercent] = useState(0);
  const [autoplay, setAutoplay] = useState(false);
  const [videoState, setVideoState] = useState(null);
  const [errorText, setErrorText] = useState('');

  useLayoutEffect(() => {
    setSource(source);
  }, [source]);

  useLayoutEffect(() => {
    if (playMode !== 'popup') {
      toggleShowPopup(false);
    }
  }, [playMode]);

  return (
    <sourceContext.Provider
      value={{
        videosSource,
        setVideosSource: setSource
      }}
    >
      <popupContext.Provider
        value={{
          showPopup,
          toggleShowPopup
        }}
      >
        <currentVideoContext.Provider
          value={{
            currentVideo,
            playing,
            percent,
            autoplay,
            videoState,
            setCurrentVideo,
            setPlaying: togglePlaying,
            setPercent: setCurrentPercent,
            setAutoplay,
            setVideoState
          }}
        >
          <errorContext.Provider
            value={{
              errorText,
              setErrorText
            }}
          >
            {children}
          </errorContext.Provider>
        </currentVideoContext.Provider>
      </popupContext.Provider>
    </sourceContext.Provider>
  );
}
